import { createSelector } from 'reselect'
import getReminderPostSampleSurveySelect from 'modules/post-sample-survey/redux/selectors/get-reminder'
import shouldShowModalPostSampleSurveyUtil from 'modules/post-sample-survey/redux/selectors/should-show-modal/utils'
import shouldShowReferralModalSelect from 'containers/ReferredModal/selectors/should-show'
import isGiftOrSelfGiftingUrlLocationUtil from 'utils/location/is-gift-or-self-gifting'

const shouldShowModalPostSampleSurveySelect = createSelector(
  getReminderPostSampleSurveySelect,
  shouldShowReferralModalSelect,
  (
    reminder,
    shouldShowReferralModal
  ) => shouldShowModalPostSampleSurveyUtil({
    reminder,
    shouldShowReferralModal,
    isGiftOrSelfGiftingUrl: isGiftOrSelfGiftingUrlLocationUtil()
  })
)
export default shouldShowModalPostSampleSurveySelect
